import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { CustomFieldsFormController } from '../controller/CustomFieldsFormController';
import { Observable } from 'rxjs';
import { FormGroupValue } from '../../../../ui/gzForm/formGroup/types/form-group-value';
import { CompanyEditingRight } from '../../types/CompanyEditingRight';

export class CustomFieldsFormWebComponent extends BaseWebComponentElement {
  public controller!: CustomFieldsFormController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: CustomFieldsFormController,
    });
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.formGroup.valid$;
  }

  public get value(): FormGroupValue {
    return this.controller.view.formGroup.value;
  }

  public get isCustomFieldsFormAvailable(): boolean {
    return this.started && this.controller.view.isCustomFieldsFormAvailable;
  }

  public get managedCompanyId(): string {
    const data = this.getAttribute('data-managed-company-id');

    return data ?? '';
  }

  public set managedCompanyId(value: string) {
    this.setAttribute('data-managed-company-id', value);
  }

  public set editingRight(editingRight: CompanyEditingRight) {
    this.setAttribute('editing-right', editingRight);
  }

  public get editingRight(): CompanyEditingRight {
    const editingRight = this.getAttribute('editing-right');
    return editingRight ? (editingRight as CompanyEditingRight) : CompanyEditingRight.Full;
  }

  public updateCustomFieldsValues(): Promise<void> {
    return this.controller.updateCustomFieldsValues();
  }

  public get hasUnsavedChanges(): boolean {
    return this.isCustomFieldsFormAvailable && this.controller.view.formGroup.hasUnsavedChanges;
  }

  public refreshInitialFormValues(): void {
    if (!this.isCustomFieldsFormAvailable) {
      return;
    }

    this.controller.view.formGroup.refreshInitialFormValue();
  }

  public discardFormChanges(): void {
    return this.controller.view.discardFormChanges();
  }
}
